<template>
  <div></div>
</template>
<script>
import * as Sentry from '@sentry/vue'
import JwtService from '../../_helpers/jwt.service'
import { REFRESH_USER } from '../../store/actions.type'

// The statuses the API's payment callback sends the user back with (paymentStatuses in the
// API), each with where the user goes on from the message. A card the bank refused comes as
// paymentPosError, with iyzico's error code in ?code=.
const RESULTS = {
  // a string is loaded again, once the user is refreshed: the paid membership changes the
  // whole app
  paymentSuccess: { type: 'is-success', next: '/' },
  paymentPosError: { type: 'is-danger', next: { name: 'payment' } },
  paymentCreateMembershipError: { type: 'is-danger', next: { name: 'home' } },
  // the card may have been charged: the user tries again and asks for a refund if it was
  paymentUnverified: { type: 'is-warning', next: { name: 'payment' } }
}
// A status this page does not know may still have charged the card, like paymentUnverified
const UNKNOWN_STATUS = 'paymentUnverified'

// Anyone can write a link to this page, so it shows no text from it: only a code that is a
// number, for the user to quote
const ERROR_CODE = /^\d{1,10}$/

// The API calls have no timeout: a refresh that hangs does not hold the button longer
const REFRESH_WAIT_MS = 10000

export default {
  mounted () {
    const { code, status: given } = this.$route.query
    // only RESULTS' own keys: ?status=constructor would find what every object inherits
    const known =
      typeof given === 'string' && Object.prototype.hasOwnProperty.call(RESULTS, given)
    const status = known ? given : UNKNOWN_STATUS
    const { type, next } = RESULTS[status]

    // The app keeps the user it signed in with; only this refresh brings the paid membership
    // and its token, so the app is not loaded again before it is done. One that fails is
    // tried once more; a paid user left as a free one until the next sign-in is reported
    let refreshed = Promise.resolve()
    if (status === 'paymentSuccess') {
      const gaveUp = new Promise(resolve => setTimeout(resolve, REFRESH_WAIT_MS))
      const refresh = this.$store
        .dispatch(REFRESH_USER)
        .catch(() => this.$store.dispatch(REFRESH_USER))
        .catch(() => {
          // without a session there is no paid user to lose: a link opened signed out goes
          // to the login page and is not reported
          if (JwtService.getToken()) {
            Sentry.captureMessage('The user could not be refreshed after a payment')
          }
        })
      refreshed = Promise.race([refresh, gaveUp])
    }

    let message = this.$t(`description.${status}`)
    // a parameter given twice comes as an array
    if (status === 'paymentPosError' && typeof code === 'string' && ERROR_CODE.test(code)) {
      message = `${message}<br><br>${this.$t('description.paymentErrorCode', [code])}`
    }
    this.$buefy.dialog.alert({
      message,
      type,
      confirmText: this.$t('button.ok'),
      canCancel: false,
      onConfirm: () => {
        if (typeof next === 'string') {
          refreshed.then(() => window.location.assign(next))
        } else {
          this.$router.push(next)
        }
      }
    })
  }
}
</script>
